module.exports = __webpack_public_path__ + "img/r-124.51659324.jpg";